import * as React from 'react';
import { ScrollToTop } from 'ui/scroll-to-top/scroll-to-top';

export interface MainGridcontainerProps {
  className?: string;
  wide?: boolean;
  children: React.ReactNode;
}

export const MainGridContainer = (props: MainGridcontainerProps) => {
  return <div className={`container main-grid ${props.className || ''} ${props.wide ? 'widebreak' : ''}`}>
    {props.children}
    <ScrollToTop />
  </div>;
};
